<template>
  <Modal width="1100" v-model="modal1" draggable sticky scrollable :mask="false" :title="$t('key1003429')">
    <div class="font-16 mt10">
      <span class="mr20"><label class="h-label">{{ $t('key1003430') }}</label>{{rowData.platformName}}</span>
      <span class="mr20"><label class="h-label">{{ $t('key1003431') }}</label>{{rowData.siteName}}</span>
      <span class="mr20"><label class="h-label">{{ $t('key1003432') }}</label>{{rowData.categoryName}}</span>
      <span v-if="rowData.platformId === 'amazon'"><label class="h-label">Product Type：</label><Select
          style="width: 190px;"
          v-model="amazonProductTypeId"
          @on-change="changeProductType"
          :placeholder="$t('key1000101')">
        <Option v-for="item in amazonProductTypeList" :value="item.amazonProductTypeId">{{item.productType}}</Option>
      </Select></span>
    </div>
    <div class="mt15">
      <Button type="primary" @click="addMapping">{{ $t('key1001340') }}</Button>
      <!--<Button type="primary" class="ml10" @click="batchMatch">批量一键匹配</Button>-->
      <!--<Tooltip content="平台属性和映射属性值完全相同可匹配成功" class="ml10">
        <Icon type="md-help-circle" size="16" />
      </Tooltip>-->
    </div>
    <Form ref="mappingForm" class="mappingForm" :model="mappingAttr" @submit.native.prevent>
      <Table class="mt10" :columns="columns" :data="mappingAttr.data"></Table>
    </Form>
    <Spin fix v-if="loading"></Spin>
    <template #footer>
      <Button @click="modal1 = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :loading="btnLoad" @click="save">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {LISTING_INPUT_TYPE} from '@/utils/enum';

export default {
  name: 'mappingAttr',
  mixins: [Mixin],
  props: {
    attrData: {
      type: Array
    },
    platformRow: {
      type: Object
    }
  },
  data () {
    let v = this;
    return {
      modal1: false,
      btnLoad: false,
      amazonProductTypeList: [],
      loading: true,
      amazonProductTypeId: '',
      amzonPublishTemplateId: '',
      ymsListingCategoryMappingId: '',
      productType: '',
      rootCategoryId: '',
      rowData: {
        platformName: '',
        siteName: '',
        categoryName: '',
        platformId: '',
        siteId: '',
        productCategoryId: ''
      },
      platformAttr: [{
        "categoryAttributeId": "2018041810462633199632",
        "inputType": "3",
        "attributeText": "Brand",
        "attributeValue": "Brand",
        "mandatory": "Y",
        "units": [],
        "isRecommended": null
      }],
      platformAttrValue: [],

      columns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003371'),
          minWidth: 190,
          align: 'center',
          render(h, params) {
            /*
            * inputType输入框类型,1-文本,2-单选不能手工输入,3-单选可以手工输入,4-多选不能手工输入,5-多选可以手工输入
            * */
            return h('FormItem',{
              props: {
                prop: 'data.' + params.index + '.platformAttributeId', //
                rules: [
                  {
                    required: true,
                    message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000681'),
                    trigger: 'change'
                  }
                ]
              }
            },[
              h('Select', {
                props: {
                  value: v.mappingAttr.data[params.index].platformAttributeId,
                  size: 'small',
                  transfer: true,
                },
                style: {
                  width: '190px',
                  textAlign: 'left'
                },
                on: {
                  'on-change'(e) {
                    let obj = v.platformAttr.filter(i=>i.attributeValue === e)[0];
                    console.log(obj);
                    v.mappingAttr.data[params.index].platformAttributeId = e;
                    v.mappingAttr.data[params.index].platformAttributeName = e;
                    v.mappingAttr.data[params.index].platformAttributeName = e;
                    v.mappingAttr.data[params.index].platformAttributeValueId = '';
                    v.mappingAttr.data[params.index].inputType = obj.inputType;
                    v.getPlatformAttrValue({
                      categoryAttributeId: obj.categoryAttributeId,
                      attributeText: ''
                    }).then(data=> {
                      v.$nextTick(() => {
                        if (['3','5'].includes(obj.inputType)) {
                          data.push({
                            attributeValue: 'CUSTOM',
                            attributeText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003378'),
                          });
                        }
                        params.row.platformAttrValue = data;
                        v.$set(v.mappingAttr.data[params.index],'platformAttrValue',data);
                      });
                    });
                  }
                }
              },v.platformAttr.map(i => {
                return h('Option', {
                  props: {
                    value: i.attributeValue
                  }
                }, i.attributeValue);
              })),
              v.mappingAttr.data[params.index].inputType === '1' && h('Input',{
                props: {
                  disabled: true,
                  size: 'small',
                  placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003417')
                },
                style: {
                  width: '190px',
                  textAlign: 'left'
                }
              }),
              (v.mappingAttr.data[params.index].platformAttributeId && v.mappingAttr.data[params.index].inputType !== '1') ? h('Select', {
                props: {
                  value: v.mappingAttr.data[params.index].platformAttributeValueId,
                  size: 'small',
                  transfer: true,
                  filterable: true,
                  clearable: true,
                  loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003418'),
                  placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003419'),
                  loading: v.mappingAttr.data[params.index]._loading,
                  // 'remote-method': function (query) {
                  //   let timer = null;
                  //   v.$set(v.mappingAttr.data[params.index], '_loading', true);
                  //   v.getPlatformAttrValue({
                  //     categoryAttributeId: v.mappingAttr.data[params.index].platformAttributeId,
                  //     attributeText: query
                  //   }).then(data => {
                  //     clearTimeout(timer);
                  //     timer = setTimeout(() => {
                  //       v.$set(v.mappingAttr.data[params.index], '_loading', false);
                  //       v.$set(v.mappingAttr.data[params.index], 'platformAttrValue', data);
                  //     }, 100);
                  //   }).catch(() => {
                  //     v.$set(v.mappingAttr.data[params.index], '_loading', false);
                  //   });
                  // },
                },
                style: {
                  width: '190px'
                },
                on: {
                  'on-query-change' (query) {
                    if (!query) {
                      v.mappingAttr.data[params.index].platformAttributeValueId = '';
                      let categoryAttributeIdObj = v.platformAttr.filter(k => k.attributeValue === v.mappingAttr.data[params.index].platformAttributeId);
                      let categoryAttributeId = categoryAttributeIdObj ? categoryAttributeIdObj[0].categoryAttributeId : null;
                      v.getPlatformAttrValue({
                        categoryAttributeId: categoryAttributeId,
                        attributeText: ''
                      }).then(data=> {
                        setTimeout(() => {
                          v.$set(v.mappingAttr.data[params.index],'_loading',false);
                          v.$set(v.mappingAttr.data[params.index],'platformAttrValue',data);
                        },100);
                      });
                    }
                  },
                  'on-clear'(e) {
                    v.mappingAttr.data[params.index].platformAttributeValueId = '';
                    let categoryAttributeIdObj = v.platformAttr.filter(k => k.attributeValue === v.mappingAttr.data[params.index].platformAttributeId);
                    let categoryAttributeId = categoryAttributeIdObj ? categoryAttributeIdObj[0].categoryAttributeId : null;
                    v.getPlatformAttrValue({
                      categoryAttributeId: categoryAttributeId,
                      attributeText: ''
                    }).then(data=> {
                      setTimeout(() => {
                        v.$set(v.mappingAttr.data[params.index],'_loading',false);
                        v.$set(v.mappingAttr.data[params.index],'platformAttrValue',data);
                      },100);
                    });
                  },
                  'on-change'(e) {
                    v.mappingAttr.data[params.index].platformAttributeValueId = e;
                    v.mappingAttr.data[params.index].platformAttributeValue = e;
                  }
                }
              }, v.mappingAttr.data[params.index].platformAttrValue.map(i => {
                return h('Option', {
                  props: {
                    key: i.attributeValue,
                    value: i.attributeValue
                  }
                }, i.attributeText);
              })) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003420'),
          align: 'center',
          minWidth: 100,
          key: 'attr',
          render(h,params) {
            let text = '-';
            LISTING_INPUT_TYPE.forEach(i => {
              if (i.value === params.row.inputType) {
                text = i.label;
              }
            });
            return h('span',text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003421'),
          align: 'center',
          minWidth: 190,
          render (h, params) {
            return h('FormItem',{
              props: {
                prop: 'data.' + params.index + '.ymsProductAttributeDictionaryId', //
                rules: [
                  {
                    required: true,
                    message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000681'),
                    trigger: 'change'
                  }
                ]
              }
            },[
              h('Select', {
                props: {
                  size: 'small',
                  value: v.mappingAttr.data[params.index].ymsCategoryProductAttributeId,
                  transfer: true
                },
                style: {
                  width: '190px',
                  textAlign: 'left'
                },
                on: {
                  'on-change'(e) {
                    v.mappingAttr.data[params.index].ymsCategoryProductAttributeId = e;
                    v.mappingAttr.data[params.index].ymsProductAttributeDictionaryId = '';
                    let obj = v.attrData.filter(i => i.ymsCategoryProductAttributeId === e)[0];
                    if (obj) {
                      v.mappingAttr.data[params.index].ymsProductAttributeTemplateId = obj.ymsProductAttributeTemplateId;
                      v.mappingAttr.data[params.index].listing = obj.listing;
                      v.getAttributeDetails(obj.ymsProductAttributeTemplateId).then(data=> {
                        v.$set(v.mappingAttr.data[params.index],'yunAttr',data.productAttributeDictionaryBos);
                      });
                    }
                  }
                }
              },v.attrData.map(i => {
                return h('Option', {
                  props: {
                    value: i.ymsCategoryProductAttributeId
                  }
                }, i.cnName);
              })),
              v.mappingAttr.data[params.index].ymsCategoryProductAttributeId ? h('Select', {
                props: {
                  size: 'small',
                  value: v.mappingAttr.data[params.index].ymsProductAttributeDictionaryId,
                  transfer: true
                },
                style: {
                  width: '190px'
                },
                nativeOn: {
                  'click' () {
                    v.getAttributeDetails(v.mappingAttr.data[params.index].ymsProductAttributeTemplateId).then(data=> {
                      v.$set(v.mappingAttr.data[params.index],'yunAttr',data.productAttributeDictionaryBos);
                    });
                  }
                },
                on: {
                  'on-change'(e) {
                    v.mappingAttr.data[params.index].ymsProductAttributeDictionaryId = e;

                  }
                }
              },params.row.yunAttr.map(i => {
                return h('Option', {
                  props: {
                    value: i.ymsProductAttributeDictionaryId
                  }
                }, i.cnValue);
              })) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003422'),
          align: 'center',
          minWidth: 200,
          render (h,params) {
            const typeArr = [{value: '1', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003423')}, {value: '2', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000304')}, {value: '3', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003424')}];
            let text = '-';
            typeArr.forEach(i => {
              if (i.value === params.row.listing) {
                text = i.label;
              }
            });
            return h('span',text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 100,
          render (h,params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: true,
                    color: '#FF0000',
                    clickFn: () => {
                      v.mappingAttr.data.splice(params.index,1);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      mappingAttr: {
        data: []
      },
    };
  },
  created () {

  },
  watch: {},
  methods: {
    changeProductType () {
      let v = this;
      _resetTableData();
      v.getPlatformAttr();

      function _resetTableData () {
        v.productType = v.amazonProductTypeList.filter(i => i.amazonProductTypeId === v.amazonProductTypeId)[0].productType;
        v.amzonPublishTemplateId = v.amazonProductTypeList.filter(i => i.amazonProductTypeId === v.amazonProductTypeId)[0].amzonPublishTemplateId;
        if (v.mappingAttr.data.length > 0 && localStorage.getItem('amazonProductType') !== '1') {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000154'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003425'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001127'),
            onOk () {
              v.mappingAttr.data = [];

            },
            onCancel () {
              v.mappingAttr.data = [];
              localStorage.setItem('amazonProductType','1');
            }
          });
        } else {
          v.mappingAttr.data = [];
        }
      }
    },
    /*获取亚马逊商品type*/
    getAmazonType () {
      let v = this;
      return new Promise(resolve => {
        v.axios.post(api.post_amazon_getProductType,{
          "rootCategoryId":v.rootCategoryId, //一级类目categoryId 或者各分类rootCategoryId （测试数据可能存在rootCategoryId 为空）
          "siteId": v.rowData.siteId
        }).then(response=> {
          if (response.data.code === 200) {
            v.amazonProductTypeList = response.data.datas;
            resolve();
          }
        });
      });
    },
    addMapping () {

      if (this.rowData.platformId === 'amazon' &&
          !this.amazonProductTypeId) {
        this.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003426'));
        return;
      }


      this.mappingAttr.data.push({
        "platformAttributeId": "",
        "platformAttributeName": "",
        "platformAttributeValue": "",
        "platformAttributeValueId": "",
        "ymsListingCategoryMappingAttributeId": "",
        "ymsListingCategoryMappingId": this.rowData.ymsListingCategoryMappingId,
        "ymsProductAttributeTemplateId": "",
        "ymsProductAttributeDictionaryId": "",
        platformAttrValue: [],
        yunAttr: []
      });
    },
    valid () {

    },
    /**
     * 获取映射属性
     * @date: 2021/9/17 20:22
     */
    getMappingDetails (ymsListingCategoryMappingId) {
      let v = this;
      return new Promise(resolve => {
        v.axios.get(api.get_ymsListingCategoryMapping + ymsListingCategoryMappingId).then(response => {
          if (response.data.code === 0) {
            resolve(response.data.datas);
          }
        });
      });
    },
    /**
     *  保存
     * @date: 2021/9/17 20:21
     */
    save () {
      let v = this;
      v.$refs.mappingForm.validate(valid => {
        if (valid) {
          let platformObj = {};
          let pValid = true;
          let amazonParams = {
            "amzonPublishTemplateId": "",
            "productType": "",
            "rootCategoryId": ""
          };
          if (v.rowData.platformId === 'amazon') {
            amazonParams = Object.assign(JSON.parse(v.rowData.extendJson),{
              amzonPublishTemplateId: v.amzonPublishTemplateId,
              amazonProductTypeId: v.amazonProductTypeId,
              productType: v.productType
            });
          }

          let params = {
            "amazonCategoryParamBo": amazonParams,
            "ymsListingCategoryMappingId": v.rowData.ymsListingCategoryMappingId,
            "updateYmsListingCategoryMappingAttributeBos": JSON.parse(JSON.stringify(v.mappingAttr.data)).map(i => {
              if (Object.prototype.hasOwnProperty.call(platformObj, i.platformAttributeId) && platformObj[i.platformAttributeId] === i.platformAttributeValueId) {
                pValid = false;
              } else {
                platformObj[i.platformAttributeId] = i.platformAttributeValueId;
              }
              delete i.yunAttr;
              delete i._loading;
              delete i.listing;
              delete i.inputType;
              return i;
            }),
            "platformId": v.rowData.platformId,
            "extendJson": "",

          };
          if (!pValid) {
            v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003427'));
            return;
          }
          /*if (v.mappingAttr.data.length < 1) {
            v.$Message.info('数据为空');
            return;
          }*/
          v.btnLoad = true;
          v.axios.post(api.post_ymsListingCategoryMappingAttribute_save,params).then(response => {
            v.btnLoad = false;
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
              v.modal1 = false;
              v.$emit('getDetails');
            }
          }).catch(()=>{
            v.btnLoad = false;
          });
        }
      });
    },
    /**
     * 一键匹配
     * @date: 2021/9/17 20:21
     */
    batchMatch () {
      let v = this;
      // 匹配属性相等
      let matchData = []; // this.mappingAttr.data
      let getIndex = 0;
      v.platformAttr.forEach((i,index) => {
        v.attrData.forEach((j,jIndex) => {
          if (i.attributeValue === j.cnName) {
            matchData.push({
              "platformAttributeId": i.categoryAttributeId, // 平台属性ID ,
              "platformAttributeName": i.attributeValue,
              "platformAttributeValue": "",
              "platformAttributeValueId": "",

              "ymsListingCategoryMappingAttributeId": '',
              "ymsListingCategoryMappingId": v.rowData.ymsListingCategoryMappingId,
              "ymsProductAttributeTemplateId": j.ymsProductAttributeTemplateId,

              listing: j.listing,
              inputType: i.inputType,
              platformAttrValue: []
            });
          }
          v.getPlatformAttrValue({
            categoryAttributeId: i.categoryAttributeId,
            attributeText: '100%'
          }).then(data => {
            getIndex++;
            if (data.length) {
              matchData.push({
                "platformAttributeId": i.categoryAttributeId, // 平台属性ID ,
                "platformAttributeName": i.attributeValue,
                "platformAttributeValue": data[0].attributeValue,
                "platformAttributeValueId": data[0].attributeValue,
                "ymsListingCategoryMappingAttributeId": '',
                "ymsListingCategoryMappingId": v.rowData.ymsListingCategoryMappingId,
                "ymsProductAttributeTemplateId": j.ymsProductAttributeTemplateId,
                listing: j.listing,
                inputType: i.inputType,
                platformAttrValue: data
              });
            }
            if (getIndex === v.platformAttr.length * v.attrData.length ) {
              if (v.mappingAttr.data.length) {
                matchData.forEach(j => {
                  if (v.mappingAttr.data.every(i => i.platformAttributeId !== j.platformAttributeId || i.platformAttributeValueId !== j.platformAttributeValueId || i.ymsProductAttributeTemplateId !== j.ymsProductAttributeTemplateId)) {
                    v.mappingAttr.data.push(j);
                  }
                });
              } else {
                v.mappingAttr.data = matchData;
              }
            }
          }).catch(() => {
            getIndex++;
            if (getIndex === v.platformAttr.length * v.attrData.length ) {
              if (v.mappingAttr.data.length) {
                matchData.forEach(j => {
                  if (v.mappingAttr.data.every(i => i.platformAttributeId !== j.platformAttributeId || i.platformAttributeValueId !== j.platformAttributeValueId || i.ymsProductAttributeTemplateId !== j.ymsProductAttributeTemplateId)) {
                    v.mappingAttr.data.push(j);
                  }
                });
              } else {
                v.mappingAttr.data = matchData;
              }
            }
          });
        });
      });
    },
    /**
     * 获取平台属性
     * @date: 2021/9/17 16:58
     * @ param
     */
    getPlatformAttr () {
      let v = this;
      return new Promise(resolve => {
        if (v.rowData.platformId === 'amazon' && !v.amzonPublishTemplateId) {
          resolve('nextGetDetail'); // getDetail 无含义只是标识
          return;
        }
        v.axios.post(api.post_category_attribute_getCommonCategoryAttributes,{
          "platformId": v.rowData.platformId,
          "siteId": v.rowData.siteId,
          "categoryId": v.rowData.categoryId,
          "amzonPublishTemplateId": v.rowData.platformId === 'amazon' ? v.amzonPublishTemplateId : undefined,
          "variationEnable":"N",
          "inputTypes": [
            "1",
            "2",
            "3",
            "4",
            "5"
          ]
        }).then(response => {
          if(response.data.code === 200) {
            v.platformAttr = response.data.datas;
            resolve(response.data.datas);
          }
        });
      });

    },
    /**
     * 获取平台属性值
     * @date: 2021/9/17 16:58
     * @ param
     */
    getPlatformAttrValue (params) {
      let v = this;
      return new Promise(resolve => {
        v.axios.post(api.post_category_attribute_variation_getAttributeValueByAttributeIdAndAttributeText,{
          categoryAttributeId: params.categoryAttributeId,
          platformId: v.rowData.platformId,
          productType: v.rowData.platformId === 'amazon' ? v.productType : undefined,
          attributeText: params.attributeText
        }).then(response=> {
          if (response.data.code === 200) {
            resolve(response.data.datas || []);
          } else {
            resolve([]);
          }
        }).catch(() => {
          resolve([]);
        });
      });

    },
    /**
     * 获取详情
     * @date: 2021/9/17 16:59
     * @param ymsListingCategoryMappingId
     */
    getDetail (ymsListingCategoryMappingId) {
      let v = this;
      return new Promise(resolve => {
        v.axios.get(api.get_ymsListingCategoryMapping + ymsListingCategoryMappingId).then(response=> {
          if (response.data.code === 0) {
            resolve(response.data.datas);
          }
        });
      });
    },
    /**
     * 获取云卖属性值
     * @date: 2021/9/17 18:07
     */
    getAttributeDetails (ymsProductAttributeTemplateId) {
      let v = this;
      return new Promise(resolve => {
        v.axios.get(api.get_ymsProductAttributeTemplate + ymsProductAttributeTemplateId).then(response => {
          if (response.data.code === 0) {
            resolve(response.data.datas);
          }
        });
      });
    },
    /**
     * 获取云卖属性值名称
     * @date: 2021/9/17 20:21
     */
    getYmsProductAttributeDictionary (ymsProductAttributeDictionaryIds) {
      let v = this;
      return new Promise(resolve => {
        v.axios.post(api.post_ymsProductAttributeDictionary_query,ymsProductAttributeDictionaryIds).then(response => {
          if (response.data.code === 0) {
            resolve(response.data.datas);
          }
        });
      });
    },
    initGetPlatformAttr () {

    },
    open (data) {
      let v = this;
      Object.assign(v.rowData,data);
      v.loading = true;
      v.modal1 = true;
      v.btnLoad = false;
      v.amzonPublishTemplateId = '';
      v.amazonProductTypeId = '';
      if (v.rowData.platformId === 'amazon') {
        let json = JSON.parse(v.rowData.extendJson);
        if (v.rowData.extendJson) {
          v.amzonPublishTemplateId = json.amzonPublishTemplateId;
          v.productType = json.productType;
          v.rootCategoryId = json.rootCategoryId;
        }
        v.getAmazonType().then(()=>{
          v.amazonProductTypeId = json.amazonProductTypeId;
        });
      }
      v.getPlatformAttr().then((platData) => {
        if (!platData || platData.length === 0) {
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003428'));
          v.mappingAttr.data = [];
          v.loading = false;
        } else {
          v.getDetail(data.ymsListingCategoryMappingId).then(data => {
            let attrName = [];
            if (data.ymsListingCategoryMappingAttributeList.length) {
              v.getYmsProductAttributeDictionary(data.ymsListingCategoryMappingAttributeList.map(i=> i.ymsProductAttributeDictionaryId)).then((data1)=>{
                attrName = data1;
                v.mappingAttr.data = data.ymsListingCategoryMappingAttributeList.map(i => {
                  i.platformAttrValue = [
                    {
                      attributeValue: i.platformAttributeValueId,
                      attributeText: i.platformAttributeValueId === 'CUSTOM' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003417'): i.platformAttributeValueId
                    }
                  ];
                  v.attrData.forEach(j => {
                    if (j.ymsCategoryProductAttributeId === i.ymsCategoryProductAttributeId) {
                      i.ymsProductAttributeTemplateId = j.ymsProductAttributeTemplateId;
                    }
                  });
                  i.listing = '-';
                  i.yunAttr = [];
                  attrName.forEach( k => {
                    if (k.ymsProductAttributeDictionaryId === i.ymsProductAttributeDictionaryId) {
                      i.yunAttr.push({
                        ymsProductAttributeDictionaryId: i.ymsProductAttributeDictionaryId,
                        cnValue: k.cnValue
                      });
                    }
                  });
                  v.attrData.forEach(j=> {
                    if (j.ymsProductAttributeTemplateId === i.ymsProductAttributeTemplateId) {
                      i.listing = j.listing;
                    }
                  });
                  i.inputType = null;
                  v.platformAttr.forEach(j=> {
                    // platformAttributeId 字面是id 实际是值 后续需注意下
                    if (j.attributeValue === i.platformAttributeId) {
                      i.inputType = j.inputType;
                    }
                  });
                  return i;
                });
              });
            } else {
              v.mappingAttr.data = [];
            }
            v.loading = false;
          });
        }
      });
    }
  }
};
</script>

<style>
.ivu-select-small.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-small.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  text-align: left;
}
</style>
<style scoped>
.font-16 {
  font-size: 16px;
}

.mr20 {
  margin-right: 20px;
}

.mt15 {
  margin-top: 15px;
}

.h-label {
  color: #333333;
  font-weight: 400;
}
</style>
